import { STAT_MAX, type StatId, type Stats } from "../game/stats";

/** A stat's rating as ten pips: the skater's starting rating in the panel's text colour, points spent on top in the accent (#225); `small` on a skater's card (#225). */
export function StatPips({ id, value, base, small = false }: { id: StatId; value: number; base: Readonly<Stats>; small?: boolean }) {
  const start = base[id];
  return (
    <span className={`inline-flex shrink-0 items-center align-middle ${small ? "ml-1 gap-px" : "ml-2 gap-0.5"}`} aria-label={`${value} of ${STAT_MAX}`}>
      {Array.from({ length: STAT_MAX }, (_, i) => (
        <span
          key={i}
          aria-hidden="true"
          className={`inline-block rounded-sm border border-ink ${small ? "h-2.5 w-1.5" : "h-3 w-2"} ${i < Math.min(value, start) ? "bg-on-surface" : i < value ? "bg-accent" : "bg-line"}`}
        />
      ))}
    </span>
  );
}
